import { Middleware } from 'redux';
import Logger, { LoggingModule } from 'services/Logger';
import analyticsService, { AmplitudeEventData, AnalyticsEvent } from 'services/AnalyticsService';
import {
  currentLocationPathNameSelector,
  previousLocationPathNameSelector
} from 'store/router/selectors';
import { getErrorCode, getErrorMessage } from 'services/api/utils';

/**
 * Catches exceptions when attempting to dispatch an action and reports it to our logging service.
 */
export const crashReportingMiddleware: Middleware = () => next => action => {
  try {
    return next(action);
  } catch (err) {
    Logger.error(`${LoggingModule.redux}redux exception caught`, {
      error: err.message,
      action: action.type
    });

    throw err;
  }
};

/**
 * Catches any action with the error property and reports it to our logging service
 */
export const errorReportingMiddleware: Middleware = ({ getState }) => next => action => {
  if (action.error) {
    const state = getState();
    const currentUrl = currentLocationPathNameSelector(state);
    const referringUrl = previousLocationPathNameSelector(state);
    const { error } = action;

    const errorCode = getErrorCode(error);
    const errorMessage = getErrorMessage(error);
    let requestId = '';

    if (error.response) {
      const { data } = error.response;
      requestId = data?.requestId || '';
    }

    const amplitudeEventData: AmplitudeEventData = {
      currentUrl,
      referringUrl,
      action: action.type,
      errorCode,
      errorMessage,
      requestId
    };
    analyticsService.logEvent(AnalyticsEvent.ErrorTracking, amplitudeEventData);
    Logger.error(`${LoggingModule.redux}redux error caught`, {
      action: action.type,
      error: action.error.message
    });
  }

  return next(action);
};
